import { createRef, useEffect } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
} from "antd";
import _ from "lodash";

import {
  FIELD_KEYS,
  FIELD_LABELS,
  FIELD_ORDERS,
  TABLE_SORTABLE_FIELDS,
} from "constants/ItemFields";
import { FILTER_KEYS, FILTER_LABELS } from "constants/table";
import FormItemSorters from "components/Common/FormItemSorters";
import FormSubmitButton from "components/Common/FormSubmitButton";
import useFetch from "hooks/useFetch";

// ###### Constants ######

const { useForm } = Form;
const { RangePicker } = DatePicker;

const sortByOptions = _.intersection(FIELD_ORDERS, TABLE_SORTABLE_FIELDS).map(
  (field) => ({
    label: FIELD_LABELS[field],
    value: field,
  })
);

// ###### Component ######

const AdvancedSearchModal = ({
  showModal,
  filters,
  onShowModalChange,
  onFiltersChange,
}) => {
  const {
    loading,
    responseData: statusOptionsResponseData,
    doFetch: fetchItemStatusOptions,
  } = useFetch("/items/getItemStatusOptions", "GET", []);
  const [form] = useForm();
  const formRef = createRef();

  const statusOptions = statusOptionsResponseData.data ?? [];

  const closeModal = (reset = true) => {
    onShowModalChange(false);
    if (reset) {
      form.resetFields();
    }
  };

  const handleAdvancedSearch = (values) => {
    onFiltersChange(values);
    closeModal(false);
  };

  useEffect(() => {
    fetchItemStatusOptions();
  }, []);

  return (
    <>
      <Modal
        title="Advanced Search"
        open={showModal}
        loading={loading}
        onCancel={closeModal}
        footer={() => (
          <>
            <Button onClick={closeModal}>Cancel</Button>,
            <FormSubmitButton
              form={form}
              label="Search"
              buttonProps={{ onClick: () => formRef.current.submit() }}
            />
          </>
        )}
        wrapClassName="modal-xl-title"
      >
        <Form
          form={form}
          ref={formRef}
          initialValues={filters}
          onFinish={handleAdvancedSearch}
          layout="vertical"
        >
          <Form.Item
            label={FILTER_LABELS[FILTER_KEYS.SEARCH]}
            name={FILTER_KEYS.SEARCH}
          >
            <Input placeholder="Search Ref No" allowClear={true} />
          </Form.Item>
          <Divider orientation="left" orientationMargin="0">
            Filters
          </Divider>
          <Row gutter={[16, 0]}>
            <Col span="12">
              <Form.Item
                label={FIELD_LABELS[FIELD_KEYS.START_DATE_TIME]}
                name={FIELD_KEYS.START_DATE_TIME}
                style={{ marginBottom: 8 }}
              >
                <RangePicker allowEmpty={[true, true]} />
              </Form.Item>
            </Col>
            <Col span="12">
              <Form.Item
                label={FIELD_LABELS[FIELD_KEYS.STATUS]}
                name={FIELD_KEYS.STATUS}
                style={{ marginBottom: 8 }}
              >
                <Select
                  options={statusOptions}
                  optionFilterProp="label"
                  mode="multiple"
                  allowClear={true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left" orientationMargin="0">
            {FILTER_LABELS[FILTER_KEYS.SORTERS]}
          </Divider>
          <FormItemSorters form={form} sortByOptions={sortByOptions} />
        </Form>
      </Modal>
    </>
  );
};

export default AdvancedSearchModal;
